import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	liveDoc: {
		id: 'live_doc_type',
		defaultMessage: 'Live Doc',
		description: 'Type text for live document',
	},
	attachment: {
		id: 'attachment_type',
		defaultMessage: 'Attachment',
		description: 'Type text for attachment',
	},
	blogpost: {
		id: 'blogpost_type',
		defaultMessage: 'Blogpost',
		description: 'Type text for blogpost',
	},
	comment: {
		id: 'comment_type',
		defaultMessage: 'Comment',
		description: 'Type text for comment',
	},
	page: {
		id: 'page_type',
		defaultMessage: 'Page',
		description: 'Type text for page',
	},
	whiteboard: {
		id: 'whiteboard_type',
		defaultMessage: 'Whiteboard',
		description: 'Type text for whiteboard',
	},
});
